import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const vendorMasterCartonsReducer = (state = {}, action) => {
  const actionName = serverApis.getMasterCartons.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.result;
    case getResetAction(actionName):
      return {};
    default:
      return state;
  }
};
